export const formatUserWhatsapp = (whatsapp?: string | null): string => {
  const value = String(whatsapp || '').trim();
  return value || '—';
};
